import { getCurrentUserRole } from "modules/utilities/utility";
import api from "../../../../../src/api/index";
import secureLocalStorage from "react-secure-storage";

export function fetchStats(sd, ed, queryParams = "") {
    return api.get(
      `get-ticket-stats/${sd}/${ed}?tab=ticket_stats${queryParams}&userRole=${getCurrentUserRole()}&userId=${secureLocalStorage.getItem("id")}`
    );
  }

  export function statsData(sd, ed) {
    return api.get(
      `get-ticket-stats/${sd}/${ed}?tab=assigned_tickets&userRole=${getCurrentUserRole()}&userId=${secureLocalStorage.getItem(
        "id"
      )}`
    );
  }
  export function statsDateFilter(sd, ed) {
    return api.get(
      `get-ticket-stats/${sd}/${ed}?tab=ticket_stats&userRole=${getCurrentUserRole()}&userId=${secureLocalStorage.getItem("id")}`
    );
  }

  export function fetchDataDownload(sd, ed) {
    return api.get(`download-ticket-data/${sd}/${ed}`);
  }
  
  export function statsUserData() {
    return api.get("users");
  }